import * as yup from 'yup';
export const checkboxValidation = yup.boolean().oneOf([true], 'Please tick the checkbox to continue.');